import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';
import { ChatbotEvents, WIDGET_SUPPORT_CHATBOT, WidgetEvents } from '@wix/wix-chatbot-common/browser';

import { widgetSDK } from '../sdk/widgetSDK';

export const postUrlChange = (url: string): void => {
  window.parent.postMessage({
    type: WIDGET_SUPPORT_CHATBOT,
    data: { event: ChatbotEvents.UPDATE_WIDGET_URL, payload: { url } },
  });
};

export const showVideoTutorials = (): void => {
  window.parent.postMessage({
    type: WIDGET_SUPPORT_CHATBOT,
    data: { event: WidgetEvents.SHOW_VIDEO_TUTORIALS },
  });
  widgetSDK.collapseWidget(WidgetClosingTrigger.VideoTutorials);
};

export const showKeyboardShortcuts = (): void => {
  window.parent.postMessage({
    type: WIDGET_SUPPORT_CHATBOT,
    data: { event: WidgetEvents.SHOW_KEYBOARD_SHORTCUTS },
  });
  widgetSDK.collapseWidget(WidgetClosingTrigger.KeyboardShortcuts);
};

export const goBackCopilot = (): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.GO_BACK_COPILOT },
    },
    '*',
  );
};

export const dismissCopilot = (): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.DISMISS_COPILOT },
    },
    '*',
  );
};

export const articleOpen = (url: string): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.ARTICLE_OPEN, url },
    },
    '*',
  );
};

export const sendMessageReady = (): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.MESSAGE_READY },
    },
    '*',
  );
};

export const copilotUpdadeChatFlow = (flow: string): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.COPILOT_UPDATE_CHAT_FLOW, flow },
    },
    '*',
  );
};

export const copilotReadyToBeInitialized = (): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.COPILOT_READY_TO_BE_INITIALIZED },
    },
    '*',
  );
};

export type FullscreenVideoItem = { id: string; url: string };

export const openVideoFullscreen = (videos: FullscreenVideoItem[], index: number): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.OPEN_VIDEO_FULLSCREEN, videos, index },
    },
    '*',
  );
};

export const closeVideoFullscreen = (): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.CLOSE_VIDEO_FULLSCREEN },
    },
    '*',
  );
};

export const openImagePreview = (url: string): void => {
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data: { event: ChatbotEvents.OPEN_IMAGE_PREVIEW, url },
    },
    '*',
  );
};

type DragEventPayload =
  | { event: 'dragStart'; clientX: number; clientY: number; screenX: number; screenY: number }
  | { event: 'dragMove'; clientX: number; clientY: number; screenX: number; screenY: number }
  | { event: 'dragEnd'; clientX?: number; clientY?: number };

export const postDragEvent = (payload: DragEventPayload): void => {
  const { event, clientX, clientY } = payload;
  const data: Record<string, unknown> = { event, clientX, clientY };
  if ('screenX' in payload) {
    data.screenX = payload.screenX;
    data.screenY = payload.screenY;
  }
  window.parent.postMessage(
    {
      type: WIDGET_SUPPORT_CHATBOT,
      data,
    },
    '*',
  );
};
